import { render, staticRenderFns } from "./BankStatement.vue?vue&type=template&id=88cb6e3e"
import script from "./BankStatement.vue?vue&type=script&lang=js"
export * from "./BankStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports